// OIDC silent-renew target. oidc-client-ts loads silent_redirect_uri (/auth/silent-renew)
// in a hidden iframe before the access token expires; this completes the renew handshake.
// Rendered standalone (before the AuthProvider tree) — see main.tsx.
// Docs: https://github.com/authts/oidc-client-ts/blob/main/docs/index.md#silent-renew

import { useEffect } from "react";
import { userManager } from "./oidc";

export function SilentRenewPage() {
  useEffect(() => {
    userManager.signinSilentCallback().catch((e: unknown) => {
      // eslint-disable-next-line no-console
      console.error("[oidc] silent renew callback failed", e);
    });
  }, []);
  return null;
}
